import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Btn, Input, Spinner } from '../components/UI';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form, setForm]   = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (!user.roles?.includes('Admin')) {
        setError('This portal is for administrators only.');
        return;
      }
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 380, animation: 'fadeIn .4s ease' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontFamily: 'var(--serif)', fontSize: 32, fontWeight: 700, color: 'var(--accent2)', lineHeight: 1 }}>
            Sulthaniya
          </div>
          <div style={{ fontSize: 11, letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--text3)', marginTop: 6 }}>
            Foundation Admin Portal
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'var(--surface)', borderRadius: 'var(--r3)',
          border: '1px solid var(--border)', padding: '32px 28px',
          boxShadow: 'var(--shadow2)',
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 6 }}>Sign in</h2>
          <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 24 }}>
            Enter your administrator credentials
          </p>

          {error && (
            <div style={{
              background: 'var(--red-bg)', border: '1px solid #f5c6c2',
              borderRadius: 'var(--r)', padding: '10px 14px', marginBottom: 16,
              fontSize: 13, color: 'var(--red)',
            }}>{error}</div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <Input
              label="Email address"
              type="email"
              placeholder="admin@sulthaniya.com"
              value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              required
            />
            <Input
              label="Password"
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              required
            />
            <Btn type="submit" disabled={loading} style={{ marginTop: 8, justifyContent: 'center', padding: '10px' }}>
              {loading ? <Spinner size={16} color="#fff"/> : 'Sign in'}
            </Btn>
          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: 11, color: 'var(--text3)', marginTop: 20 }}>
          Sulthaniya Foundation © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
